import React from "react";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import DropDownList from "../../../../../../ReusableComponents/DropDownList/DropDownList";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import nodeinstance from "../../../../../../nodeInstance";
import { list } from "postcss";

export default function ReNewPopUpUpdate({
  list,
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
  token,
}) {
  console.log("list", list);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [id, setId] = useState();
  const setIdValue = (id) => {
    console.log("ms scc", id.target.value);
    setId(id.target.value);
  };

  const update = async (type) => {
    try {
      console.log("clicked log to be printed in console",type);
      const res = await nodeinstance.post(url, type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
      if (res.status == 200) {
        setPopUp(false);
        callBack();
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto  rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full flex flex-col gap-3 my-3 p-5 items-center place-items-center">
            <div className="flex flex-col gap-1">
              <label className="text-sm font-bold ">{title}</label>
            </div>
          </div>
          <div className="flex flex-row items-center justify-center gap-2 place-items-center">
            <label className="label text-center">
              <span className="label-text  justify-center place-items-center pb-4">
                TENURE
              </span>
            </label>
            <DropDownList
              value={""}
              setValue={setIdValue}
              presetValues={[
                { value: "90 Days" },
                { value: "180 Days" },
                { value: "270 Days" },
                { value: "360 Days" },
                { value: "540 Days" },
                { value: "630 Days" },
                { value: "720 Days" },
                { value: "810 Days" },
                { value: "900 Days" },
                { value: "990 Days" },
                { value: "1080 Days" },
              ]}
            />
          </div>

          <div
            className="flex gap-3 w-full justify-center"
            style={{ margin: 2 }}
          >
            <button
              onClick={() => {
                update({
                  employee_id: list,
                  tenure: id,
                });
              }}
              type="submit"
              className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
            >
              {" "}
              <p>Submit</p>
              {loading ? <CgSpinner className="animate-spin" /> : ""}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
